import HTTP from '@/framework/utilities/http'
import querystring from 'querystring'

export default {

  login ({ userName, password }) {
    let query = {
      username: userName,
      password: password,
      grant_type: 'password'
    }

    return HTTP.post('/token',
      querystring.stringify(query),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
    )
  },

  logout () {
    return HTTP.post('account/logout')
  },

  getUserDetails () {
    return HTTP.get('user/details')
  },

  register ({ userName, password }) {
    let query = {
      email: userName,
      password: password,
      confirmPassword: password
    }

    return HTTP.post('account/register', query)
  }
}
